/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.8",
    versionName: "0.2.0-nightly.2026.1.8",
    versionChannel: "nightly",
    buildDate: "2026-01-08T00:09:26.874Z",
    commitHash: "f0fa0a3d1db88970527c79323a910715801dbd6a",
};
